import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, price, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-canvas" data-id="element-98" data-mp="9lv16qmocfvu">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-99" data-mp="9ipcvdlvdi16">
        <Pill tone="gold" data-id="element-100" data-mp="4n9wadwh9812">Per insegnanti di yoga</Pill>

        <h1 className="mx-auto mt-4 max-w-3xl font-serif text-[2.1rem] font-bold leading-[1.05] text-ink sm:text-[3.1rem] lg:text-[3.8rem]" data-id="element-101" data-mp="12a0kd8y2xwtk">
          Pianifica la tua prossima lezione di yoga{' '}
          <span className="text-accent" data-id="element-102" data-mp="sartwq2fb0by">in meno di 10 minuti</span>
        </h1>

        <div className="relative mt-7" data-id="element-103" data-mp="nc87kojx3mj2">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-3xl bg-surface" aria-hidden="true" data-id="element-104" data-mp="nb6n5th0hnoo" />
          <img src={heroImage} alt="Yoga Kit Pro™: cofanetto con 6 volumi (Vinyasa, Hatha, Yin, Posturale, Pranayama, Emergenza), tablet con il piano di classe e i 5 bonus strategici." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-105" data-mp="3d2bidl8y6rtf" />
        </div>

        <p className="mx-auto mt-4 max-w-prose font-sans text-sm leading-relaxed text-muted sm:text-base" data-id="element-106" data-mp="39b4fyxmj3o1c">
          70+ lezioni strutturate in 6 volumi, con script, varianti e 5 bonus
          strategici per insegnanti di yoga. Tutto pronto da insegnare da oggi.
        </p>

        <div className="mt-7" data-id="element-107" data-mp="358hmyte4fx2k">
          <CtaButton size="large" className="w-full sm:w-auto" data-id="element-108" data-mp="359syjfdt6948">
            Accedi subito — {price}
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-109" data-mp="2qhqv5lcj4xzg">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-muted sm:text-xs" data-id="element-110" data-mp="2vgu25bc2lea2">
              <CheckIcon className="h-3.5 w-3.5 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-111" data-mp="2lkqzm4db3dml" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-line bg-card" data-id="element-112" data-mp="s3mcu1g2bwxu">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-6" data-id="element-113" data-mp="nbl1chqpya8v">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-3 py-7 text-center" data-id="element-114" data-mp="ibp0ush8d0y2">
              <dt className="mt-2 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-muted sm:text-xs" data-id="element-115" data-mp="ddf0m3gnfa5l">
                {stat.label}
              </dt>
              <dd className="font-serif text-5xl font-bold leading-none text-accent sm:text-6xl" data-id="element-116" data-mp="1ayt5uxgbpf9u">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}